export default function BlueCursor() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 46 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.56641 3.34326L13.1489 48.6564L22.2134 29.418L43.3491 27.0591L3.56641 3.34326Z" fill="#1C5DCC" stroke="black" stroke-width="5.30401" stroke-linejoin="round" />
        </svg>

    )
}